<template>
  <div>
    <div v-if="loading" class="text-xs-center"></div>
    <div v-else-if="!url" class="text-xs-center">
      <v-icon x-large>highlight_off</v-icon>
      <div>Not found video</div>
    </div>
    <template v-else>
      <slot v-bind="{ url, mime_type }"> </slot>
    </template>
  </div>
</template>

<script>
import facebookApi from '@/api/facebook'
export default {
  props: ['value', 'type'],
  data() {
    return {
      loading: true,
      url: '',
      mime_type: null
    }
  },
  async mounted() {
    this.loading = true

    try {
      let resData = await facebookApi.getAttachments(this.value)
      if (this.type == 'image') {
        if (
          resData &&
          resData.data &&
          resData.data.data &&
          resData.data.data[0] &&
          resData.data.data[0].image_data &&
          resData.data.data[0].image_data.url
        ) {
          this.url = resData.data.data[0].image_data.url
        }
      } else {
        if (
          resData &&
          resData.data &&
          resData.data.data &&
          resData.data.data[0] &&
          resData.data.data[0].video_data &&
          resData.data.data[0].video_data.url
        ) {
          this.url = resData.data.data[0].video_data.url
          this.mime_type = resData.data.data[0].video_data.mime_type
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FacebookContent.vue